module.exports = __webpack_public_path__ + "static/img/7-1.29518b6e.png";